export enum TaskStatus {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  POSTPONED = 'POSTPONED',
  ALL = 'ALL',
  REVIEW = 'REVIEW',
}